import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import ChatTour from "components/Tour/ChatTour";

import { getIsOpenSense, getStep, updateIsOpenNewChat, getIsOpenNewChat, updateStep } from "containers/Tour/reducer";
import { updateType } from "containers/View/reducer";
import * as viewReducer from "containers/View/reducer";
import * as chatGPTReducer from "containers/ChatGPT/reducer";

class ChatTourContainer extends React.PureComponent {
  render() {
    return <ChatTour {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateIsOpenNewChat: (isOpen) => dispatch(updateIsOpenNewChat(isOpen)),
    updateStep: (step) => dispatch(updateStep(step)),
    updateType: (type) => dispatch(updateType(type)),
    selectBlueprint: (blueprintId) => dispatch(chatGPTReducer.selectBlueprint(blueprintId)),
    updateIsUpload: (bool) => dispatch(chatGPTReducer.updateIsUploadDocument(bool)),
    updateArtifactId: (val) => dispatch(chatGPTReducer.updateArtifactId(val))
  };
};

const mapStateToProps = (state, ownProps) => {
  const isOpen = getIsOpenNewChat(state);

  return {
    isOpen: isOpen,
    step: getStep(state),
    selectedBlueprintId: (state) => chatGPTReducer.getBlueprintId(state),
    selectedArtifact: (state) => getArtifact(state, "CORPUS", artifactId ?? -1)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ChatTourContainer);
